<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Plany urlopowe innych</span>
        <h3 class="page-title">Lista planów urlopowych</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          v-if="createHolidayPlans"
          theme="success"
          @click.prevent="$router.push('/plany-urlopowe-innych/dodaj')">
          <i class="material-icons">add</i>
          Dodaj plan urlopowy
        </d-button>
        <d-button
          style="width: 175px;"
          class="ml-2"
          theme="info"
          @click.prevent="openModal">
          <i class="material-icons">book_online</i>
          Pobierz raport planów
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="institutions-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <date-picker
          v-model="filters.date_start"
          valueType="format"
          class="mr-2"
          style="width: 100%"
          :title="'Rozpoczęcie planu urlopowego'"
        />
        <date-picker
          v-model="filters.date_end"
          valueType="format"
          class="mr-2"
          style="width: 100%"
          :title="'Rozpoczęcie planu urlopowego'"
        />
        <d-input
          placeholder="Podaj imię lub nazwisko pracownika"
          v-model="filters.search"/>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Imię i Nazwisko</th>
          <th scope="col" class="border-0">Rozpoczęcie planu urlopowego</th>
          <th scope="col" class="border-0">Zakończenie planu urlopowego</th>
          <th scope="col" class="border-0">Dodany przez</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(plan, index) of holidaysPlans"
          :key="'institution-' + index">
          <td class="align-middle">
            {{ plan.user_name }}
          </td>
          <td class="align-middle">
            {{ plan.date_start }}
          </td>
          <td class="align-middle">
            {{ plan.date_end }}
          </td>
          <td class="align-middle">
            {{ plan.created_by ? plan.created_by.name + ' ' + plan.created_by.last_name : '' }}
          </td>
          <td
            class="align-middle"
            style="width: 200px;">
            <d-button
              v-if="plan.holidays_count !== 0"
              :disabled="plan.holidays_count !== 0"
              outline
              theme="info"
              class="mr-2"
              title="Urlop został dodany">
              <i class="material-icons">{{plan.holidays_count === 0 ? 'add' : 'done'}}</i>
              {{plan.holidays_count === 0 ? '' : 'Urlop został dodany'}}
            </d-button>
            <d-button
              v-if="plan.holidays_count === 0 && createHolidayPlans"
              theme="primary"
              @click.prevent="$router.push('/plany-urlopowe-innych/edycja/' + plan.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              v-if="plan.holidays_count === 0 && createHolidayPlans"
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeHolidaysPlans(plan.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="holidaysPlans.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak placówek do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>
      <holidays-children-report
        :key="modalKey"
        :close-modal="closeModal"
        :show-modal="showModal"
        :label="'Wygeneruj plany urlopowe'"
        :plans="true"/>
      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>
<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import DatePicker from 'vue2-datepicker';
import HolidaysChildrenReport from './HolidaysChildrenReport';

export default {
  name: 'institutions',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    HolidaysChildrenReport,
    'pagination': Pagination,
    DatePicker
  },
  computed: {
    createHolidayPlans () {
      const account = this.$store.state.userAccount.data.data;

      return account.role !== 'R_RECEPTION' ||
        (account.role === 'R_RECEPTION' && account.create_holiday_plans === 1);
    }
  },
  data() {
    return {
      holidaysPlans: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      showModal: false,
      modalKey: 0,
      filters: {
        date_start: '',
        date_end: '',
        search: ''
      },
    };
  },
  mounted () {
    console.log(this.$store.state.userAccount.data.data.create_holiday_plans);
    this.userAccountGet();
    this.loadFilteredData();
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    openModal () {
      this.modalKey += 1;
      this.showModal = true;
    },
    closeModal () {
      this.modalKey += 1;
      this.showModal = false;
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search,
        date_start: this.filters.date_start,
        date_end: this.filters.date_end
      };

      ListUtils.loadItemsData(this, {
        endpoint: '/holidays-plans/users/items?page=' + this.currentPage,
        listField: 'holidaysPlans',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        date_start: '',
        date_end: '',
        search: '',
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['institutions-filters-form'], this.debouncedLoadFilteredData);
    },
    removeHolidaysPlans (holidaysPlansID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/holidays-plans/users/delete/',
        id: holidaysPlansID,
        successTitle: 'Usunięto plan urlopowy',
        successText: 'Wybrany plan urlopowy został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten plan urlopowy?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie planu urlopowego nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
